import { login, logout,loginCheckCode } from "@/api/api";
import {loginPot} from "@/api/apiPot";
import { getNavbarData } from "../actions";
import { behaviorloginOut, behaviorlogin, } from '@/api/apiPot.js'
import { getToken, setToken, removeToken,getPotToken,setPotToken } from "@/utils/auth";
// import { behaviorpageAccess} from '@/api/apiPot.js'
const state = {
    potToken: getPotToken(),
    token: getToken(),
    id: window.localStorage.getItem("userId") || "", //用户ID
    userName: window.localStorage.getItem("userName") || "", // 用户名
    userAllData: window.localStorage.getItem("userInfo") ?
        JSON.parse(window.localStorage.getItem("userInfo")) : {} //用户所有数据
};

const mutations = {
    SET_USER_INFO: (state, userInfo) => {
        state.userAllData = userInfo;

        state.id = "";
        state.userName = "";
        if (userInfo) {
            state.id = userInfo.user_id;
            state.userName = userInfo.user_name;
        }
    },
    SET_POT_TOKEN: (state, token) => {
        state.potToken = token;
    },
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_NAME: (state, name) => {
        state.userName = name;
    }
};

const actions = {
    /**
     * 登录
     */
    login({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            login(userInfo)
                .then(res => {
                    const data = res.data;
                    setToken(data.token); //存储token
                    setUserInfo(commit, data.user); //存储用户信息
                    commit("SET_TOKEN", data.token);
                    // commit("SET_POT_TOKEN", data.token);
                    commit("app/SET_INDEX_POP_STATE", 0, { root: true });
                    console.log('data',data);
                    console.log('data.user.name:',data.user.user_name);
                    loginPot({name:data.user.user_name})
                        .then(res => {
                            const data2 = res.data;
                            // setToken(data.token); //存储token
                            // setUserInfo(commit, data.user); //存储用户信息
                            // commit("SET_TOKEN", data.token);
                            commit("SET_POT_TOKEN", data2.token);
                            setPotToken(data2.token); //存储token
                            // commit("app/SET_INDEX_POP_STATE", 0, { root: true });
                            console.log('getPotToken123',getPotToken());
                            if(data2.token){
                              setTimeout(() => {
                                behaviorlogin({ ip: localStorage.getItem('ipAddress'), inlet_index: '登入',login_device:3 }).then(() => {
                                });
                                // behaviorpageAccess({ page_index: '首页',superior_index:'登录',residence_time:1000})
                              },1000)
                            }
                            // resolve(data);
                        })
                        .catch(error => {
                            console.log('error',error);
                        });
                    resolve(data);

                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    loginCode({ commit }, sign) {
        return new Promise((resolve, reject) => {
            loginCheckCode({ sign: sign })
                .then(res => {
                    if (res.data.status==1) {
                        const data = res.data;
                        setToken(data.token); //存储token
                        setUserInfo(commit, data.user); //存储用户信息
                        commit("SET_TOKEN", data.token);
                        // commit("SET_POT_TOKEN", data.token);
                        commit("app/SET_INDEX_POP_STATE", 0, { root: true });
                        console.log('data----',data);
                        loginPot({name:data.user.user_name})
                            .then(res => {
                                const data2 = res.data;
                                // setToken(data.token); //存储token
                                // setUserInfo(commit, data.user); //存储用户信息
                                // commit("SET_TOKEN", data.token);
                                commit("SET_POT_TOKEN", data2.token);
                                setPotToken(data2.token); //存储token
                                // commit("app/SET_INDEX_POP_STATE", 0, { root: true });
                                console.log('getPotToken1234',getPotToken());
                                if(data2.token){
                                  setTimeout(() => {
                                    behaviorlogin({ ip: localStorage.getItem('ipAddress'), inlet_index: '登入',login_device:3 }).then(() => {
                                    });
                                  },1000)
                                }
                                // resolve(data);
                            })
                            .catch(error => {
                                console.log('error',error);
                            });
                        resolve(data);
                    } else if(res.data.status==2) {
                        reject( '二维码已过期，刷新页面后重试！')
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    },


    /**
     * 退出登录
     */
    logout({ commit }) {
        return new Promise(async resolve => {
            try {
                // await logout();
                commit("SET_TOKEN", "");
                commit("SET_USER_INFO", "");
                clearLocalUserInfo(); //删除本地用户信息
                behaviorloginOut({ leave_index: '退出登录' }).then(res => {
                    console.log(res);
                    commit("SET_POT_TOKEN", '');
                    setPotToken('');
                });

                resolve();
            } catch (error) {
                console.log(error);
            }
        });
    },

    /**
     * 移除token
     */
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit("SET_TOKEN", "");
            removeToken();
            resolve();
        });
    },
    /**更新用户所有信息 此方法会实时更新所有监听了用户信息变动的页面
     *  调用举例    this.$store.dispatch("user/setUserAllData", userInfo);
     *  尽量不直接去更新storage里的数据  更新storage刷新后才有效果  直接调用上述方法可在监听的数据中都生效
     */
    setUserAllData({ commit }, userInfo) {
        return new Promise(resolve => {
            setUserInfo(commit, userInfo); //更新用户信息
            resolve();
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};

export const setUserInfo = (commit, userData) => {
    commit("SET_USER_INFO", userData); //设置用户数据
    setLocalUserInfo(userData); //存储用户信息
};

//清除本地数据
const clearLocalUserInfo = () => {
    const savedUsername = window.localStorage.getItem('loginusername');
    const savedPassword = window.localStorage.getItem('loginpassword');
    removeToken();
    window.localStorage.removeItem("userInfo");
    window.localStorage.removeItem("userName");
    window.localStorage.clear();
    window.localStorage.setItem('loginusername', savedUsername);
    window.localStorage.setItem('loginpassword', savedPassword);
};

//存储本地数据
const setLocalUserInfo = userData => {

    window.localStorage.setItem("userInfo", JSON.stringify(userData));
    window.localStorage.setItem("userName", userData.user_name);
    window.localStorage.setItem("userNameInfo", userData.name);
};



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js